import { ValueOf } from "../type";

export const DocumentSignKey = {
  PaginateDocumentSigns: "PAGINATE_DOCUMENT_SIGNS",
  DocumentSign: "DOCUMENT_SIGN",
  DocumentSignMergeStatus: "DOCUMENT_SIGN_MERGE_STATUS",
  DocumentSignDocsPdfPage: "DOCUMENT_SIGN_DOCS_PDF_PAGE",
} as const;

export type DocumentSignKeyType = ValueOf<typeof DocumentSignKey>;
